import { ProductWorkspacePage } from "../ProductWorkspacePage";

/**
 * The /products/:productId/edit route.
 *
 * A route adapter and nothing else. This file used to hold a second, parallel
 * product editor: its own classification radios with a free-text frame shape,
 * its own details form, its own colour list, its own save loop, its own
 * validate call and its own Publish Changes button. Every one of those existed
 * a second time in the workspace, and the two copies had already diverged —
 * this screen would accept a frame shape the phone cannot filter by, and the
 * workspace would not.
 *
 * Editing is now the workspace's edit mode, reached identically from the
 * Products List, from this route, and from a resumed import.
 */
export function EditProductPage() {
  return <ProductWorkspacePage mode="edit" />;
}
